import { render, staticRenderFns } from "./userList.vue?vue&type=template&id=1653f47f&scoped=true&"
import script from "./userList.vue?vue&type=script&lang=js&"
export * from "./userList.vue?vue&type=script&lang=js&"
import style0 from "./userList.vue?vue&type=style&index=0&id=1653f47f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1653f47f",
  null
  
)

export default component.exports